module.exports = __webpack_public_path__ + "organizations.9d37e04472cba8a1a35e593e83ca48f7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/organizations.svg
// module id = 335
// module chunks = 0